<div class="card-box clearfix">
	<div id="schema-notfound">
		{{TR "Leider gibt es für diesen Anlagentyp momentan keine graphische Darstellung."}}
	</div>
</div>
